/**
 * ClientBox — read-only summary of who this registration is for.
 * Extracted from CompanyRegistrationDetailPage.jsx during the iter-238 refactor.
 * iter-264c — Also shows the newly-captured business essentials
 * (activities, proposed license names, ownership type).
 */
import React from 'react';
import { User, Activity, Sparkles, Users2 } from 'lucide-react';
import { SectionCard, KV } from './ui';

export function ClientBox({ reg, t, isAr }) {
  const c = reg.client || {};
  const activities    = Array.isArray(reg.activities)    ? reg.activities    : [];
  const licenseNames  = Array.isArray(reg.license_names) ? reg.license_names : [];
  const ownership     = reg.ownership || null;

  return (
    <SectionCard icon={User} iconColor="#f59e0b" title={t('المُقدَّم لأجله الطلب', 'Requested for (Client)')}>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <KV k={t('الاسم', 'Name')} v={c.name || '—'} />
        <KV k={t('الهاتف', 'Phone')} v={c.phone || '—'} dir="ltr" />
        <KV k={t('البريد الإلكتروني', 'Email')} v={c.email || '—'} dir="ltr" />
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 border-t border-white/5">
        <KV k={t('الدولة', 'Country')} v={isAr ? (reg.country_name_ar || reg.country_name_en) : (reg.country_name_en || reg.country_name_ar)} />
        <KV k={t('الإمارة/المنطقة', 'Region')} v={isAr ? (reg.region_name_ar || reg.region_name_en) : (reg.region_name_en || reg.region_name_ar)} />
        <KV k={t('الجهة', 'Authority')} v={isAr ? (reg.authority_name_ar || reg.authority_name_en) : (reg.authority_name_en || reg.authority_name_ar)} />
      </div>

      {(activities.length > 0 || licenseNames.length > 0 || ownership) && (
        <div className="mt-4 pt-4 border-t border-white/5 space-y-3" data-testid="reg-profile-block">
          {activities.length > 0 && (
            <div>
              <div className="text-xs text-[#71717A] mb-1.5 flex items-center gap-1">
                <Activity className="h-3.5 w-3.5 text-emerald-400" />
                {t('أنشطة الشركة', 'Company Activities')}
              </div>
              <div className="flex flex-wrap gap-1.5">
                {activities.map((a, i) => (
                  <span
                    key={i}
                    className="px-2 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-200 text-[11px]"
                    data-testid={`reg-activity-${i}`}
                  >
                    {a}
                  </span>
                ))}
              </div>
            </div>
          )}

          {licenseNames.length > 0 && (
            <div>
              <div className="text-xs text-[#71717A] mb-1.5 flex items-center gap-1">
                <Sparkles className="h-3.5 w-3.5 text-yellow-400" />
                {t('أسماء الرخصة المقترحة', 'Proposed License Names')}
              </div>
              <ol className="list-decimal ps-5 text-sm text-white/90 space-y-0.5">
                {licenseNames.map((n, i) => (
                  <li key={i} data-testid={`reg-license-name-${i}`}>{n || '—'}</li>
                ))}
              </ol>
            </div>
          )}

          {ownership && (
            <div>
              <div className="text-xs text-[#71717A] mb-1.5 flex items-center gap-1">
                <Users2 className="h-3.5 w-3.5 text-cyan-400" />
                {t('نوع الملكية', 'Ownership')}
              </div>
              <div className="text-sm text-white/90" data-testid="reg-ownership-summary">
                {ownership.type === 'partners' ? (
                  <>
                    {t('شركاء', 'Partners')}
                    <span className="mx-1 text-white/40">·</span>
                    {t('العدد:', 'Count:')} <span className="font-bold text-cyan-300">{ownership.partner_count || 0}</span>
                  </>
                ) : (
                  <>{t('مالك واحد', 'Single owner')}</>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </SectionCard>
  );
}
